<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/orders">Orders</Link>
      <span class="text-indigo-400 font-medium">/</span>
      #{{ order.order_id }}
    </h1>
    <div class="w-full text-right mb-4">
      <button v-if="order.status === 'confirmed'" class="mt-2 mb-4 ml-auto text-white bg-green-500 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" @click="mark_order_as_completed(order.id)">
        <icon name="check" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Mark as Dispatched
      </button>

      <button v-if="order.status === 'cancelled'" class="mt-2 mb-4 ml-auto text-white bg-green-500 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" @click="mark_order_as_cancelled(order.id)">
        <icon name="check" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Mark as Cancelled
      </button>

      <button v-if="order.status === 'dispatched'" class="mt-2 ml-auto text-white bg-red-500 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" @click="open_undo_modal(order)">
        <icon name="undo" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Undo Dispatch
      </button>

      <button v-if="order.status === 'cancel_completed'" class="mt-2 ml-auto text-white bg-red-500 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" @click="open_undo_modal(order)">
        <icon name="undo" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Undo Cancelled
      </button>
    </div>
    <div class=" m-auto grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
      <div class="bg-white rounded-md shadow overflow-hidden">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/2 whitespace-pre-wrap break-all">Name:  <div class="pt-4 pb-4 font-bold">{{order.name}}</div></div>
          <div class="pb-8 pr-6 w-full lg:w-1/2">Phone:  <div class="pt-4 pb-4 font-bold">{{order.phone_number}}</div></div>
          <div class="pb-8 pr-6 w-full lg:w-1/2 whitespace-pre-wrap break-all">Email:  <div class="pt-4 pb-4 font-bold">{{order.email}}</div></div>
          <div class="pb-8 pr-6 w-full lg:w-1/2">Total:  <div class="pt-4 pb-4 font-bold">₹ {{order.value}}</div></div>
          <div class="pb-8 pr-6 w-full">Shipping Address:
            <div class="pt-4 pb-4 font-bold">
              {{ order.shipping_address.address1 }}<br>
              <span v-if="order.shipping_address.address2">{{ order.shipping_address.address2}}<br></span>
              {{ order.shipping_address.city }}<br>
              {{ order.shipping_address.province }} {{ order.shipping_address.zip }}
            </div>
          </div>
          <div class="pb-8 pr-6 w-full">Billing Address:
            <div class="pt-4 pb-4 font-bold">
              {{ order.billing_address.address1 }}<br>
              <span v-if="order.billing_address.address2">{{ order.billing_address.address2}}<br></span>
              {{ order.billing_address.city }}<br>
              {{ order.billing_address.province }} {{ order.billing_address.zip }}
            </div>
          </div>
          <div class="pb-8 pr-6 w-full lg:w-1/2">Order Date:  <div class="pt-4 pb-4 font-bold">{{order.ordered_at}} ({{order.date_time}})</div></div>
          <div class="pb-8 pr-6 w-full lg:w-1/2" v-if="order.cancel_reason">Cancelled Reason:  <div class="pt-4 pb-4 font-bold">{{order.cancel_reason}}</div></div>
          <div class="pb-8 pr-6 w-full lg:w-1/2">Payment Method:  <div class="pt-4 pb-4 font-bold">{{order.payment_method}}</div></div>
        </div>
      </div>
      <div class="bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 p-8">
            <div class="pb-8 pr-6 w-full">
              <span class="pb-8 pr-6 w-full font-bold">Action</span>
            </div>
            <hr>
            <a :href="`https://admin.shopify.com/store/caed65-3/orders/${order.shopify_id}`" target="_blank" class="btn-indigo bg-blue-500 w-full p-5">
              <icon name="arrow-right" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" />
              View in Shopify
            </a>
            <a :href="`https://healthunbox.unicommerce.com/order/orderitems?orderCode=${order.shopify_id}#viewName=All&skipLocationChange=undefined`" target="_blank" class=" w-full btn-grey ml-auto bg-blue-500 my-5 p-5">
              <icon name="arrow-right" class=" mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" />
              View in Unicommerce
            </a>

          </div>
        </form>

        <hr class="border-b-2">
        <div class="p-2 mt-4 ml-2">
          <a :href='`https://live-5203.wati.io/teamInbox/?filter={"filterType":0}&search={"searchString":"${order.phone_number}"}`' target="_blank" class="mt-2 block ml-2 text-white bg-green-700 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">
            <icon name="whatsapp" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" />
            Send WhatsApp Message</a>
          <a :href='`tel:${order.phone_number}`' target="_blank" class="mt-2 ml-2  block text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            <icon name="call" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> Call Customer
          </a>

        </div>
      </div>
      <div class="bg-white rounded-md shadow overflow-hidden">

        <form @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <div class="pb-8 pr-6 w-full">
              <span class="pb-8 pr-6 w-full font-bold">Notes / History</span>
            </div>
            <hr>
            <form @submit.prevent="add_note">
              <div class="flex flex-wrap w-full">
                <textarea-input v-model="note.note" :error="note.errors.note" class="pb-8 w-full" label="Note" />
                <loading-button :loading="note.processing" class="btn-indigo mb-10" type="submit">Add Note</loading-button>
              </div>
            </form>
            <div v-for="note in order.notes" class="flex flex-wrap w-full bg-orange-100 text-black p-2 rounded mb-2">
              {{note.note}}
              <span class="w-full pt-2"><small>{{note.noted_at}}</small></span>
            </div>
          </div>
        </form>
      </div>
    </div>


    <h2 class="mt-12 text-2xl font-bold">Items</h2>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6"></th>
          <th class="pb-4 pt-6 px-6">Product</th>
          <th class="pb-4 pt-6 px-6">SKU</th>
          <th class="pb-4 pt-6 px-6">Quantity</th>
          <th class="pb-4 pt-6 px-6">Amount</th>
        </tr>
        <tr v-for="item in order.line_items" :key="item.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t" style="width: 100px">
            -
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/contacts/${item.id}/edit`">
              {{ item.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${item.id}/edit`" tabindex="-1">
              {{ item.sku }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/contacts/${item.id}/edit`" tabindex="-1">
              {{ item.quantity }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/contacts/${item.id}/edit`" tabindex="-1">
              ₹  {{ item.price }}
            </Link>
          </td>
        </tr>
        <tr v-if="order.line_items.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No items found.</td>
        </tr>
      </table>
    </div>

    <modal v-model="show_undo_modal" @confirm="undo_action(undo_order, form.undo_reason)" @cancel="cancel">
      <template v-slot:title>Undo Order #{{ undo_order.id }} Status</template>
      <textarea-input v-model="form.undo_reason" class="pb-8 pr-6 w-full" label="Undo Reason" />
    </modal>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '@/Shared/TextareaInput'
import Modal from '@/Shared/Modal.vue'

export default {
  components: {
    TextareaInput,
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Modal,

  },
  layout: Layout,
  props: {
    order: Object,
    cancel_reasons: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        status: this.order.status,
        cancel_reason: this.order.cancel_reason,
        cancel_reason_other: '',
        undo_reason: null,
      }),
      note: this.$inertia.form({
        note: '',
      }),
      undo_order: [],
      show_undo_modal: false,
    }
  },
  methods: {
    update() {
      this.form.put(`/orders/${this.order.id}`)
    },

    add_note() {
      this.note.put(`/orders/${this.order.id}/note`)
    },

    mark_order_as_completed (order_id) {
      this.$inertia.post('/dispatch/dispatch_orders', {'order_ids': [order_id]})
    },

    mark_order_as_cancelled (order_id) {
      this.$inertia.post('/dispatch/cancel_orders', {'order_ids': [order_id]})
    },

    open_undo_modal(order) {
      this.undo_order = order
      this.form.undo_reason = ''
      this.show_undo_modal = true
    },

    undo_action (order, reason) {

      if (reason.length < 5) {
        window.alert('Please enter a valid undo reason.')
        return
      }

      if (order.status === 'dispatched') {
        this.undo_complete_order(order.id, reason)
      }

      if (order.status === 'cancel_completed') {
        this.undo_cancelled_order(order.id, reason)
      }

      this.show_undo_modal = false;
    },

    undo_complete_order (order_id, reason) {
      this.$inertia.post('/dispatch/dispatch_orders', {'order_ids': [order_id], undo: true, undo_reason: reason})
    },

    undo_cancelled_order (order_id, reason) {
      this.$inertia.post('/dispatch/cancel_orders', {'order_ids': [order_id], undo: true, undo_reason: reason})
    },

    destroy() {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$inertia.delete(`/organizations/${this.organization.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put(`/organizations/${this.organization.id}/restore`)
      }
    },
  },
}
</script>
